import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { filter, switchMap } from 'rxjs/operators';

import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';

import { AzureAuthService } from './azure-auth.service';

@Injectable()
export class AzureInterceptor implements HttpInterceptor {
  private readonly azureAuthService = inject(AzureAuthService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (environment.AADB2C.apiConfig.visitorUri && req.url.startsWith(environment.AADB2C.apiConfig.visitorUri)) {
      return next.handle(req);
    }
    if (req.url.startsWith(environment.AADB2C.apiConfig.uri)) {
      return this.azureAuthService.getTokenFromCache().pipe(
        filter(result => result !== null),
        switchMap(result => {
          const authReq = req.clone({ headers: req.headers.set('Authorization', `Bearer ${result.idToken}`) });
          return next.handle(authReq);
        })
      );
    }

    return next.handle(req);
  }
}
